import { FC } from 'react';
import TaxAdvantageAccountsPlan from 'model/TaxAdvantageAccountsPlan';
import { EMPLOYER_FREQUENCY_PLAN_LABEL_MAPPING } from 'modules/taxAdvantaged/constants/taxAdvantagedConstants';
import ContributionField from 'modules/taxAdvantaged/components/ContributionField/ContributionField';
import { hasErContributionValue } from 'modules/taxAdvantaged/taxAdvantageUtil';
import { useAppSelector } from 'hooks/redux';
import {
  MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_SEPARATELY,
  MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_JOINTLY_OR_SINGLE_TEXT,
  END_OF_YEAR_POLICY,
} from 'constants/languageConstants';
import { getText } from 'utils/stringUtil';

import styles from './dcapFsaPlanInfo.module.less';

type Props = {
  plan: TaxAdvantageAccountsPlan;
};

const DcapFsaPlanInfo: FC<Props> = (props: Props) => {
  const { plan } = props;
  const { employerContribution } = plan;
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.container}>
      {employerContribution &&
        employerContribution.frequency &&
        hasErContributionValue(employerContribution) && (
          <div className={styles.empContribution}>
            <div className={styles.frequency}>{`Employer Contribution per ${
              EMPLOYER_FREQUENCY_PLAN_LABEL_MAPPING[
                employerContribution.frequency
              ]
            }`}</div>
            <ContributionField
              label=""
              value={employerContribution.empContribution}
              type="employer"
            />
          </div>
        )}
      <div className={styles.frequency}>
        {employerContribution.otherContribution}
      </div>
      {plan.maxIndividualContributionForMarriedButFilledAsSeparately !== null &&
        plan.maxIndividualContributionForMarriedButFilledAsSeparately !==
          undefined && (
          <ContributionField
            label={getText(
              MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_SEPARATELY,
              language
            )}
            value={
              plan.maxIndividualContributionForMarriedButFilledAsSeparately
            }
          />
        )}
      {plan.maxMarriedContributionForFillingJointlyOrSingleParentAsHead !==
        null &&
        plan.maxMarriedContributionForFillingJointlyOrSingleParentAsHead !==
          undefined && (
          <ContributionField
            label={getText(
              MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_JOINTLY_OR_SINGLE_TEXT,
              language
            )}
            value={
              plan.maxMarriedContributionForFillingJointlyOrSingleParentAsHead
            }
          />
        )}
      {plan.endOfYearPolicy && (
        <ContributionField
          label={getText(END_OF_YEAR_POLICY, language)}
          valueText={plan.endOfYearPolicy}
          valueEndOfYearPolicyField={true}
        />
      )}
    </div>
  );
};

export default DcapFsaPlanInfo;
